		
import ScrollMagic from "scrollmagic";
require("../ScrollMagicIndicators");

function initTimeline(version = "v1") {
  const pageContainer = document.querySelector(`.timeline-${version}`);
  const line = document.querySelector(`.timeline-${version} .timeline__line`);

  if (!line) return;

  const controller = new ScrollMagic.Controller();
  const initScene = new ScrollMagic.Scene({
    offset: 100,
    duration: pageContainer.offsetHeight,
    triggerElement: `.timeline-${version} .timeline__item-wrapper`,
    reverse: false,
  })
    .triggerHook("onEnter")
    .addTo(controller)
    // .addIndicators();

  initScene.on("progress", (progressEvent) => {
    const { progress } = progressEvent;
    line.style.height = (progress * 100).toFixed(2) + "%";
  });

	initScene.on("end", () => {
		jQuery('.timeline-arrow__wrapper').hide();
	});

  // // Row History
  const items = document.querySelectorAll(
    `.timeline-${version} .timeline__item`
  );

  items.forEach((item, index) => {
    const scene = new ScrollMagic.Scene({
      triggerElement: item,
      offset: item.offsetHeight / 2,
      reverse: false,
    })

      .triggerHook("onEnter")
      // .setPin(".className") // pins the element for the the scene's duration
      .addTo(controller)
      // .addIndicators({
      //   name: "ITEM-" + index,
      // });

    scene.on("start", (event) => {
      item.classList.add("timeline__item--animating");
    });
  });
}

initTimeline();




